export default "__VITE_ASSET__jScwsyNT__"